const STORAGE_KEY = 'aiClerk:returnPath'
const FALLBACK_PATH = '/photo/all'

function pathnameOf(path: string): string {
  return path.split('?')[0] || ''
}

function isSafeAppPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false
  const pathname = pathnameOf(path)
  if (pathname === '/ai/clerk' || pathname.startsWith('/ai/clerk/'))
    return false
  if (pathname.startsWith('/login') || pathname.startsWith('/choose_group')) {
    return false
  }
  return true
}

/**
 * 记住进入填表员之前的页面。只在非填表员路由上写入，避免工作台内部跳转覆盖来源。
 *
 * @param path - 当前页的 pathname + search
 *
 * @example
 * ```ts
 * rememberWorkspaceReturnPath('/watermark/data?tab=1')
 * ```
 */
export function rememberWorkspaceReturnPath(path: string): void {
  if (!isSafeAppPath(path)) return
  try {
    window.sessionStorage.setItem(STORAGE_KEY, path)
  } catch {
    // sessionStorage 不可用时返回仍走兜底路径。
  }
}

/**
 * 读取离开填表员时应回到的页面。没有有效来源时回全部照片。
 *
 * @returns 站内路径（含 query）
 *
 * @example
 * ```ts
 * readWorkspaceReturnPath() // "/watermark/data?tab=1"
 * ```
 */
export function readWorkspaceReturnPath(): string {
  try {
    const stored = window.sessionStorage.getItem(STORAGE_KEY) || ''
    return isSafeAppPath(stored) ? stored : FALLBACK_PATH
  } catch {
    return FALLBACK_PATH
  }
}
